var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "side-panel-template" },
    [
      _c(
        "div",
        {
          ref: "header",
          staticClass: "side-panel-header pt-4",
          class: {
            "top-sticky-blur top-sticky-blur-neutral negative-mx-5 px-5":
              _vm.stickyHeader,
            "d-none-after": _vm.hidePanelTitle
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "inner",
              class: { "mb-2": _vm.stickyHeader && _vm.hidePanelTitle }
            },
            [
              _c(
                "div",
                { staticClass: "fx-row-center w-100 no-min-width" },
                [
                  _vm._t("headerIcon"),
                  _vm._v(" "),
                  _vm.backRoute
                    ? _c("router-link", {
                        attrs: { to: _vm.backRoute, custom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var navigate = ref.navigate
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "txt-primary mr-2",
                                      attrs: { role: "link" },
                                      on: {
                                        click: function($event) {
                                          return _vm.go(navigate, $event)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icon-regular",
                                          attrs: {
                                            width: "24",
                                            viewBox: "0 0 24 24"
                                          }
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              "xlink:href": "#icon-arrow-left"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "back-label" },
                                        [_vm._v(_vm._s(_vm.backLabel))]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3335300249
                        )
                      })
                    : _vm.topTitle && _vm.rename
                    ? _c("side-panel-title", {
                        key: _vm.$route.fullPath + _vm.titleKey,
                        ref: "title",
                        staticClass: "mb-none",
                        attrs: {
                          error: _vm.titleError,
                          "error-message": _vm.titleErrorMessage,
                          "show-actions": _vm.renameActions,
                          editable: _vm.rename
                        },
                        on: {
                          blur: function($event) {
                            return _vm.$emit("blurTitle")
                          }
                        },
                        model: {
                          value: _vm.titleModel,
                          callback: function($$v) {
                            _vm.titleModel = $$v
                          },
                          expression: "titleModel"
                        }
                      })
                    : _vm.topTitle
                    ? _c(
                        "h3",
                        { staticClass: "txt-title-small mb-0 txt-bold" },
                        [_vm._v(_vm._s(_vm.topTitle))]
                      )
                    : _vm.hub && !_vm.topLabel
                    ? _c("h3", { staticClass: "txt-body txt-muted" }, [
                        _vm._v(_vm._s(_vm.hub.title))
                      ])
                    : _vm.innerTitle
                    ? _c(
                        "h3",
                        { staticClass: "txt-title-small mb-0 txt-bold" },
                        [_vm._v(_vm._s(_vm.innerTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.topLabel && !_vm.backRoute && !_vm.hub
                    ? _c(
                        "div",
                        {
                          staticClass: "top-label pt-1 mr-auto",
                          class:
                            (_vm.$route.name === "LibraryFolder" ||
                              _vm.$route.params.noBackRoute) &&
                            _vm.$route.name !== "MediaPage"
                              ? "txt-title-small txt-dark mb-0 txt-bold"
                              : "txt-body txt-muted"
                        },
                        [_vm._v(_vm._s(_vm.topLabel))]
                      )
                    : _vm.topLabel
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "top-label pt-1 mr-auto txt-body txt-muted"
                        },
                        [_vm._v(_vm._s(_vm.topLabel))]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { variant: "icon ml-3", size: "sm" },
                  on: { click: _vm.closePanel }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon-sm",
                      attrs: { width: "24", viewBox: "0 0 24 24" }
                    },
                    [_c("use", { attrs: { "xlink:href": "#icon-cross" } })]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.titleModel && !_vm.hidePanelTitle
            ? _c(
                "div",
                { staticClass: "inner" },
                [
                  _c("side-panel-title", {
                    key: _vm.$route.fullPath + _vm.titleKey,
                    ref: "title",
                    staticClass: "mb-auto",
                    attrs: {
                      error: _vm.titleError,
                      "error-message": _vm.titleErrorMessage,
                      "show-actions": _vm.renameActions,
                      editable: _vm.rename
                    },
                    on: {
                      blur: function($event) {
                        return _vm.$emit("blurTitle")
                      }
                    },
                    model: {
                      value: _vm.titleModel,
                      callback: function($$v) {
                        _vm.titleModel = $$v
                      },
                      expression: "titleModel"
                    }
                  }),
                  _vm._v(" "),
                  _vm._t("actions")
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("header")
        ],
        2
      ),
      _vm._v(" "),
      _vm.topTitle && _vm.documents
        ? _c("h3", { staticClass: "txt-title-small mb-0" }, [
            _vm._v(_vm._s(_vm.topTitle))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("p", { staticClass: "txt-body txt-muted mb-2" }, [
            _vm._v(_vm._s(_vm.description))
          ])
        : _vm._t("description"),
      _vm._v(" "),
      _c("div", { staticClass: "side-panel-body" }, [_vm._t("default")], 2)
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }